/* Custom Accordion Logic for MMCC */
document.addEventListener('DOMContentLoaded', function() {
  const accordionButtons = document.querySelectorAll('.accordion-header');
  
  accordionButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Determine the current expanded state
      const isExpanded = button.getAttribute('aria-expanded') === 'true' || false;
      
      // Toggle the expanded state on the button
      button.setAttribute('aria-expanded', !isExpanded);
      
      // Get the corresponding content div (the next sibling element)
      const content = button.nextElementSibling;
      
      if (content && content.classList.contains('accordion-content')) {
        // Toggle the expanded state on the content div for CSS to control max-height
        content.setAttribute('aria-expanded', !isExpanded);
      }
    });
  });
});